import Modal from "@/common/components/Modal";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import { EstablishmentCompanyData } from "@/common/types/establishment/company.type";
import { FormTransformers } from "@/common/utils/formTransformers";
import { useDeleteEstablishmentCompanyMaintenanceSpecialty } from "@/features/establishments/hooks/maintenanceModels/useDeleteEstablishmentCompanyMaintenanceSpecialty";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

interface DeleteMaintenanceSpecialtyModalProps {
  establishmentCompany: EstablishmentCompanyData;
  maintenanceSpecialtyId: string;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

const DeleteMaintenanceSpecialtyModal = ({
  establishmentCompany,
  maintenanceSpecialtyId,
  isOpen,
  setIsOpen,
}: DeleteMaintenanceSpecialtyModalProps) => {
  const queryClient = useQueryClient();
  const [messages, setMessages] = useState<string[] | boolean>(false);

  const {
    mutate: deleteMaintenanceSpecialty,
    isPending: deleteMaintenanceSpecialtyIsPending,
  } = useDeleteEstablishmentCompanyMaintenanceSpecialty({
    establishmentCompanyId: establishmentCompany.id,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['establishmentCompany', establishmentCompany.id] });

      setIsOpen(false);
    },
    onError: FormTransformers.errorsTransformer({
      setMessages,
    }),
  });

  return (
    <div onClick={(event) => event.stopPropagation()}>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        useCancellableFooter
        confirmButtonClassName="rounded-br-lg"
        cancelButtonClassName="rounded-bl-lg"
        onConfirm={() => deleteMaintenanceSpecialty(maintenanceSpecialtyId)}
        confirmButtonIsLoading={deleteMaintenanceSpecialtyIsPending}
        title="Você tem certeza?"
        subtitle="Essa ação não é reversível."
        titleClass="text-2xl"
        subtitleClassName="text-base mt-1"
        showClose={false}
      />

      <ModalMessageSimple
        messages={messages}
        setMessages={setMessages}
        isError
      />
    </div>
  );
}

export default DeleteMaintenanceSpecialtyModal;
